import React from "react";
import WhatIsPTE from "../assets/utility/what_pte.jpg"

export default function PTEContent() {
  return (
    <main className="mt-5 mx-20 px-2 sm:px-4">

      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
        Importance of Best PTE Coaching Classes
      </h1>

      <div className="space-y-4 text-gray-700 text-base leading-relaxed">
        <p className="text-justify">
          Are you planning to work or study overseas and aiming to achieve your desired score in the PTE (Pearson Test of English) exam? Enrolling in one of the best PTE coaching classes can equip you with the right skills, strategies, and confidence to excel in every section of the test.
        </p>

        <p className="text-justify">
          The PTE is widely recognized by universities, colleges, and governments worldwide as a trusted assessment of English language proficiency for non-native speakers. As a globally accepted test for international education and migration, it plays a crucial role in helping candidates achieve their academic and career goals abroad.
        </p>

        <p className="text-justify">
          A professional PTE Coaching Institute not only prepares you for the exam format but also strengthens your overall communication skills in English. Through structured training, expert guidance, and regular practice, candidates can significantly improve their reading, writing, speaking, and listening abilities.
        </p>

        <p className="text-justify">
          With the right preparation, dedication, and expert support, success in the PTE exam is within your reach.
        </p>
      </div>

      <section className="mt-10">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
          What is PTE?
        </h2>

        <div className="flex flex-col md:flex-row items-center gap-8 text-gray-700 text-base leading-relaxed">

          {/* Left Content */}
          <div className="md:w-1/2 space-y-4">
            <p className="text-justify">
              The Pearson Test of English (PTE) is an English proficiency exam administered by Pearson PLC. It allows non-native English speakers to demonstrate their English skills when applying to study, work, or migrate abroad.
            </p>

            <p className="text-justify">
              Countries like Canada, the USA, Australia, New Zealand, and the UK widely accept PTE scores. Universities and employers across the globe recognize PTE as proof of strong English communication skills.
            </p>

            <p className="text-justify">
              The exam evaluates candidates across four sections: Speaking, Writing, Listening, and Reading. A high PTE score reflects your ability to communicate effectively in English, showcasing your readiness to pursue education or build a career in English-speaking countries.
            </p>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 flex justify-center">
            <img
              src={WhatIsPTE}
              alt="What is PTE"
              className="w-full max-h-[350px] rounded-lg shadow-lg object-cover"
            />
          </div>

        </div>      </section>

      <section className="mt-10">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
          Types of PTE Tests
        </h2>

        <ul className="list-disc mx-10 space-y-4 text-gray-700 text-base">
          <li>
            <span className="font-semibold text-gray-900">PTE Academic:</span>{" "}
            Most popular for study and immigration purposes.
          </li>

          <li>
            <span className="font-semibold text-gray-900">PTE General:</span>{" "}
            Designed for visas, employment, and general English proficiency (Levels A1 to 5).
          </li>

          <li>
            <span className="font-semibold text-gray-900">PTE UKVI:</span>{" "}
            Accredited for UK visas and university admissions.
          </li>

          <li>
            <span className="font-semibold text-gray-900">PTE Young Learners:</span>{" "}
            Designed for children aged 6–13 in interactive formats.
          </li>

          <li>
            <span className="font-semibold text-gray-900">PTE Home:</span>{" "}
            Online test for UK family or employment visas and citizenship.
          </li>
        </ul>
      </section>

    </main>
  );
}